import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.eiffel = bracketIndenting({
	line: "--",
})
